import { useAPI } from '@providers/useAPI';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { JobsService } from 'app/API';
import { jobsKeys } from 'app/queries/jobs/jobsKeys';

type TEditJobRequest = Parameters<typeof JobsService.editJob>[0];

export const useEditJobMutation = () => {
  const { call } = useAPI();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (request: TEditJobRequest) => call(() => JobsService.editJob(request)),
    onSettled: (_data, _error, { jobId }) =>
      Promise.all([
        queryClient.invalidateQueries({ queryKey: jobsKeys.lists() }),
        queryClient.invalidateQueries({ queryKey: jobsKeys.detail(jobId), refetchType: 'none' }),
      ]),
  });
};
